import React from 'react';
import { Tooltip, Typography } from '@mui/material';
import { DeviceGroupChipProps } from '@modules/digital-signage/model/group-settings.model.ts';

const DeviceGroupChip: React.FC<DeviceGroupChipProps> = ({ name }) => (
  <Tooltip title={name} placement="top">
    <Typography
      variant="caption"
      component="span"
      noWrap
      className="block max-w-24 shrink-0 h-5 px-2 rounded-full bg-(--blue-12) text-[11px]! font-semibold! leading-5! text-(--blue-1)!"
    >
      {name}
    </Typography>
  </Tooltip>
);

export default DeviceGroupChip;
